/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {SpeciesIndexPage} from "../Common/SpeciesIndexPage";
import {
    commonName,
    growthForm,
    invasivity,
    isDefault,
    nativity,
    scientificName
} from "../Common/SpeciesTable/ColumnDefinitions";
import {GlobalSpeciesTableFilter} from "./GlobalSpeciesTableFilter";
import {SpeciesRequestModal} from "../Common/Modals/SpeciesRequestModal";
import {usePermission} from "../../../../Hooks/PermissionHooks";

import {AddSpeciesModal} from "../Common/Modals/AddSpeciesModal";
import {EditSpeciesModal} from "../Common/Modals/EditSpeciesModal";
import {ViewSpeciesModal} from "../Common/Modals/ViewSpeciesModal";

export const GlobalSpeciesPage = props => {
    const permission = usePermission();
    const canEdit = permission?.('can_alter_global_species_list');
    
    return <SpeciesIndexPage
        title="Global Species List"
        filterComponent={GlobalSpeciesTableFilter}
        columnDefinitions={[
            scientificName,
            commonName,
            growthForm,
            nativity,
            invasivity,
            isDefault,
        ]}
        addModalComponent={canEdit ? AddSpeciesModal : SpeciesRequestModal}
        addSpeciesButtonLabel={canEdit ? "Add A Species" : "Request A New Species"}
        editModalComponent={canEdit ? EditSpeciesModal : ViewSpeciesModal}
        sortColumn={'scientificName'}
        {...props}
    />
};
